// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2-8Rb","notes":"Notes_notes__YhqhH","note":"Notes_note__23X6t","markdown":"Notes_markdown__3J3Uv"};